// Discovers the visitor's IPv4 and IPv6 addresses. The IPv4-only and IPv6-only
// hostnames each report the address of the connection used to reach them, so
// asking both reveals both families. The entry page needs both because the
// visitor arrives over IPv6 while nova.pohoda.runde.cz is IPv4-only, so the RDP
// session comes from a different address than the one that clicked Vstup.

async function fetchIp(host) {
  try {
    const response = await fetch(`https://${host}/ip`, { mode: "cors" });
    if (!response.ok) return null;

    const data = await response.json();
    return data.ip;
  } catch (error) {
    return null;
  }
}

// Asks the hostnames named in the element's dataset and returns the distinct
// addresses that answered. A hostname that is unreachable is simply skipped.
async function detectAddresses(element) {
  const hosts = [element.dataset.ipv4Host, element.dataset.ipv6Host].filter(Boolean);
  const found = await Promise.all(hosts.map(fetchIp));

  return Array.from(new Set(found.filter(Boolean)));
}

function hiddenAddressField(ip) {
  const input = document.createElement("input");
  input.type = "hidden";
  input.name = "ips[]";
  input.value = ip;

  return input;
}

// Request form: adds the discovered addresses to whatever the field already has.
async function prefillAddresses() {
  const field = document.getElementById("ip_addresses");
  if (!field) return;

  const addresses = new Set(
    field.value.split(/[\s,]+/).filter((value) => value.length > 0)
  );

  const found = await detectAddresses(field);
  found.forEach((ip) => addresses.add(ip));

  field.value = Array.from(addresses).join("\n");
}

// Entry page: shows the visitor which addresses Vstup will open the firewall
// for, and sends them along with the form so both families get opened.
async function prepareEnterForm() {
  const form = document.getElementById("enter-form");
  if (!form) return;

  const addresses = await detectAddresses(form);
  addresses.forEach((ip) => form.appendChild(hiddenAddressField(ip)));

  const summary = document.getElementById("detected-addresses");
  if (!summary || addresses.length === 0) return;

  summary.textContent = `${summary.dataset.label} ${addresses.join(", ")}`;
  summary.hidden = false;
}

document.addEventListener("DOMContentLoaded", prefillAddresses);
document.addEventListener("DOMContentLoaded", prepareEnterForm);
